import * as ambassadorWixAchievementsInstructorsV2Instructor from './achievements-instructors-v2-instructor-instructors.http.js';
import * as ambassadorWixAchievementsInstructorsV2InstructorTypes from './achievements-instructors-v2-instructor-instructors.types.js';
import * as ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes from './achievements-instructors-v2-instructor-instructors.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createInstructor(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.CreateInstructorRequest,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.CreateInstructorRequest,
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.CreateInstructorResponse,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.CreateInstructorResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAchievementsInstructorsV2Instructor.createInstructor(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/instructors',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function inviteInstructor(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.InviteInstructorRequest,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.InviteInstructorRequest,
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.InviteInstructorResponse,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.InviteInstructorResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAchievementsInstructorsV2Instructor.inviteInstructor(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/instructors/invite',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listInstructors(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.ListInstructorsRequest,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.ListInstructorsRequest,
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.ListInstructorsResponse,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.ListInstructorsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAchievementsInstructorsV2Instructor.listInstructors(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/instructors/list',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryInstructors(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.QueryInstructorsRequest,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.QueryInstructorsRequest,
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.QueryInstructorsResponse,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.QueryInstructorsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAchievementsInstructorsV2Instructor.queryInstructors(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/instructors/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateInstructor(): __PublicMethodMetaInfo<
  'PATCH',
  { instructorId: string },
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.UpdateInstructorRequest,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.UpdateInstructorRequest,
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.UpdateInstructorResponse,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.UpdateInstructorResponse
> {
  const payload = { instructor: { id: ':instructorId' } } as any;

  const getRequestOptions =
    ambassadorWixAchievementsInstructorsV2Instructor.updateInstructor(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/instructors/{instructor.id}',
    pathParams: { instructorId: 'instructorId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteInstructor(): __PublicMethodMetaInfo<
  'DELETE',
  { instructorId: string },
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.DeleteInstructorRequest,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.DeleteInstructorRequest,
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.DeleteInstructorResponse,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.DeleteInstructorResponse
> {
  const payload = { instructorId: ':instructorId' } as any;

  const getRequestOptions =
    ambassadorWixAchievementsInstructorsV2Instructor.deleteInstructor(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/instructors/{instructorId}',
    pathParams: { instructorId: 'instructorId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function assignInstructorToProgram(): __PublicMethodMetaInfo<
  'POST',
  { instructorId: string },
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.AssignInstructorToProgramRequest,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.AssignInstructorToProgramRequest,
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.AssignInstructorToProgramResponse,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.AssignInstructorToProgramResponse
> {
  const payload = { instructorId: ':instructorId' } as any;

  const getRequestOptions =
    ambassadorWixAchievementsInstructorsV2Instructor.assignInstructorToProgram(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/instructors/{instructorId}/assign',
    pathParams: { instructorId: 'instructorId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function unassignInstructorFromProgram(): __PublicMethodMetaInfo<
  'POST',
  { instructorId: string },
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.UnassignInstructorFromProgramRequest,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.UnassignInstructorFromProgramRequest,
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.UnassignInstructorFromProgramResponse,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.UnassignInstructorFromProgramResponse
> {
  const payload = { instructorId: ':instructorId' } as any;

  const getRequestOptions =
    ambassadorWixAchievementsInstructorsV2Instructor.unassignInstructorFromProgram(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/instructors/{instructorId}/unassign',
    pathParams: { instructorId: 'instructorId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function changeProgramInstructors(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.ChangeProgramInstructorsRequest,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.ChangeProgramInstructorsRequest,
  ambassadorWixAchievementsInstructorsV2InstructorUniversalTypes.ChangeProgramInstructorsResponse,
  ambassadorWixAchievementsInstructorsV2InstructorTypes.ChangeProgramInstructorsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAchievementsInstructorsV2Instructor.changeProgramInstructors(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/assignments',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Instructor as InstructorOriginal,
  Image as ImageOriginal,
  Role as RoleOriginal,
  RoleWithLiterals as RoleWithLiteralsOriginal,
  InstructorWasAssigned as InstructorWasAssignedOriginal,
  InstructorWasUnassigned as InstructorWasUnassignedOriginal,
  CreateInstructorRequest as CreateInstructorRequestOriginal,
  CreateInstructorResponse as CreateInstructorResponseOriginal,
  InviteInstructorRequest as InviteInstructorRequestOriginal,
  InviteInstructorResponse as InviteInstructorResponseOriginal,
  ListInstructorsRequest as ListInstructorsRequestOriginal,
  Paging as PagingOriginal,
  ListInstructorsResponse as ListInstructorsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  QueryInstructorsRequest as QueryInstructorsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryInstructorsResponse as QueryInstructorsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  UpdateInstructorRequest as UpdateInstructorRequestOriginal,
  UpdateInstructorResponse as UpdateInstructorResponseOriginal,
  UpdateInstructorRoleRequest as UpdateInstructorRoleRequestOriginal,
  UpdateInstructorRoleResponse as UpdateInstructorRoleResponseOriginal,
  DeleteInstructorRequest as DeleteInstructorRequestOriginal,
  DeleteInstructorResponse as DeleteInstructorResponseOriginal,
  AssignInstructorToProgramRequest as AssignInstructorToProgramRequestOriginal,
  AssignInstructorToProgramResponse as AssignInstructorToProgramResponseOriginal,
  UnassignInstructorFromProgramRequest as UnassignInstructorFromProgramRequestOriginal,
  UnassignInstructorFromProgramResponse as UnassignInstructorFromProgramResponseOriginal,
  ChangeProgramInstructorsRequest as ChangeProgramInstructorsRequestOriginal,
  ChangeProgramInstructorsResponse as ChangeProgramInstructorsResponseOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  PolicyAssignedToContributor as PolicyAssignedToContributorOriginal,
  NoUserIdInCallScopeErrorDetails as NoUserIdInCallScopeErrorDetailsOriginal,
  PolicyRemovedFromContributor as PolicyRemovedFromContributorOriginal,
  PolicyUpdatedForContributor as PolicyUpdatedForContributorOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  UpdateInstructorApplicationErrors as UpdateInstructorApplicationErrorsOriginal,
  ChangeProgramInstructorsApplicationErrors as ChangeProgramInstructorsApplicationErrorsOriginal,
} from './achievements-instructors-v2-instructor-instructors.types.js';
